import React, {
    useEffect,
    useMemo,
    useState
} from "react";
import axios from "axios";
import moment from "moment-timezone";
import {
    useNavigate
} from "react-router-dom";
import {
    IoLockClosedOutline,
    IoAlertCircleOutline,
    IoCalendarOutline,
    IoInfiniteOutline,
    IoCardOutline,
    IoLogoWhatsapp,
    IoClose,
} from "react-icons/io5";
import {
    getCustomUser
} from "../api";
const TZ = "Asia/Baku";
const PLANS = [ {
    id: "p50",
    label: "Aylıq Abunəlik",
    subLabel: "Ayın 1-dən ayın 1-nə",
    amount: 5.0,
    icon: "calendar",
    accent: "#0B6A36",
    bg: "#E7F3EF",
},
    {
        id: "p500",
        label: "Ömürlük Abunəlik",
        subLabel: "Bir dəfə ödə — həmişə aktiv",
        amount: 500.0,
        icon: "infinite",
        accent: "#7C3AED",
        bg: "#F3E8FF",
    },
];
const iconMap = {
    calendar: IoCalendarOutline,
    infinite: IoInfiniteOutline,
};

const AppMessageModal = ({
    open,
    title = "Diqqət",
    message = "", type = "info",
    onClose,
}) => {
    if (!open) return null;

    return (
        <div className="sq-modal-overlay">
            <div className="sq-alert-modal">
                <button className="sq-close-btn" onClick={onClose} type="button">
                    <IoClose size={22} />
                </button>

                <h3 className={`sq-alert-title sq-alert-${type}`}>{title}</h3>
                <p className="sq-alert-message">
                    {message}
                </p>

                <button className="sq-alert-button" onClick={onClose} type="button">
                    Bağla
                </button>
            </div>
        </div>

    );
};

const SubModal = () => {
    const navigate = useNavigate();

    const [showModal,
        setShowModal] = useState(false);
    const [payUrl,
        setPayUrl] = useState(null);
    const [payOpen,
        setPayOpen] = useState(false);
    const [checking,
        setChecking] = useState(true);

    const [selectedPlanId,
        setSelectedPlanId] = useState(PLANS[0].id);

    const [messageModal,
        setMessageModal] = useState( {
            open: false,
            title: "",
            message: "",
            type: "info",
        });

    const selectedPlan = useMemo(
        () => PLANS.find((p) => p.id === selectedPlanId) || PLANS[0],
        [selectedPlanId]
    );

    const showMessage = ({
        title, message, type = "info"
    }) => {
        setMessageModal({
            open: true,
            title,
            message,
            type,
        });
    };

    useEffect(() => {
        const checkSubscription = async () => {
            try {
                setChecking(true);
                const storedUserId = localStorage.getItem("id");
                if (!storedUserId) {
                    setShowModal(true);
                    return;
                }

                const response = await getCustomUser(storedUserId);
                const u = response?.data;

                const now = moment.tz(TZ);
                const exp = u?.expiryDate ? moment(u.expiryDate).tz(TZ): null;
                const hasValidActiveSub =
                !!u?.isSub && !!exp && exp.isValid() && exp.isAfter(now);

                if (!hasValidActiveSub) {
                    setShowModal(true);
                }
            } catch (err) {
                console.error("Abunəlik yoxlaması zamanı xəta:", err);
                setShowModal(true);
            } finally {
                setChecking(false);
            }
        };

        checkSubscription();

    },
        []);

    const handlePayment = async () => {
        try {
            const uId = localStorage.getItem("id");
            if (!uId) {
                showMessage( {
                    title: "Xəta",
                    message: "İstifadəçi tapılmadı. Yenidən daxil olun.",
                    type: "error",
                });
                return;
            }

            const plan = selectedPlan;
            const isMonthly = plan.id === "p50";
            const orderId = `abune_${plan.id}_${uId}_${Date.now()}`;

            const description = isMonthly
            ? "Sifariş Qrupu – Aylıq abunəlik (5 AZN) | Ayın 1-dən ayın 1-nə": `Sifariş Qrupu – Ömürlük abunəlik (${plan.amount} AZN)`;

            const days = isMonthly ? 30: 3650;

            const successUrl =
  `https://mototaksi.az/success?userId=${uId}` +
  `&type=abuneliksifarisqrupu` +
  `&days=${days}` +
  `&plan=${plan.id}` +
  `&amount=${plan.amount}` +
  `&orderId=${orderId}`;

            const response = await axios.post(
                "https://mototaksi.az:9898/api/v5/payment-init",
                {
                    amount: plan.amount,
                    orderId,
                    description,
                    meta: {
                        plan: plan.id,
                        mode: isMonthly ? "p50": "p500",
                    },
                    successUrl,
                    errorUrl: "https://mototaksi.az/error",
                },
                {
                    timeout: 20000
                }
            );

            const redirectUrl = response?.data;

            if (redirectUrl) {
                setShowModal(false);
                setPayUrl(redirectUrl);
                setPayOpen(true);
            } else {
                showMessage( {
                    title: "Xəta",
                    message: "Ödəniş linki tapılmadı.",
                    type: "error",
                });
            }
        } catch (err) {
            console.error("Ödəniş xətası:", err?.response?.data || err?.message);
            showMessage( {
                title: "Xəta",
                message: "Ödənişə keçid mümkün olmadı.",
                type: "error",
            });
        }

    };

    const handleContactSupport = () => {
        const phoneNumber = "994709559984";
        const message =
        "Salam, Sifariş Qrupu tətbiqində abunəliyimi aktivləşdirmək istəyirəm.";
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, "_blank");

    };

    const handleClosePay = () => {
        setPayOpen(false);
        setShowModal(false);
        navigate("/sifaris/order-group", {
            replace: true
        });
    };

    return (
        <>
            {showModal && (
                <div className="sq-modal-overlay">
                    <div className="sq-sub-sheet">
                        <div className="sq-sub-topbar">
                            <div className="sq-sub-top-left">
                                <div className="sq-sub-logo-circle">
                                    <IoLockClosedOutline size={18} color="#075E54" />
                                </div>
                                <div>
                                    <div className="sq-sub-top-title">
                                        Abunəlik tələb olunur
                                    </div>
                                    <div className="sq-sub-top-sub">
                                        Sifariş Qrupundan tam istifadə üçün seçin
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="sq-sub-rule-card">
                            <IoAlertCircleOutline size={18} color="#92400E" />
                            <div className="sq-sub-rule-content">
                                <div className="sq-sub-rule-title">
                                    Aylıq plan qaydası
                                </div>
                                <div className="sq-sub-rule-text">
                                    Aylıq ödəniş <strong>ayın 1-dən ayın 1-nə</strong> hesablanır.
                                    Məsələn: 1 Yanvar → 1 Fevral.
                                </div>
                            </div>
                        </div>

                        <div className="sq-sub-section-title">
                            Plan seçin
                        </div>

                        <div className="sq-sub-plan-list">
                            {PLANS.map((p) => {
                                const active = p.id === selectedPlanId;
                                const Icon = iconMap[p.icon];

                                return (
                                    <button
                                        key={p.id}
                                        type="button"
                                        onClick={() => setSelectedPlanId(p.id)}
                                        className={`sq-sub-plan-card ${active ? "sq-sub-plan-card-active": ""}`}
                                        style={ {
                                            backgroundColor: p.bg,
                                            borderColor: active ? p.accent: "transparent",
                                        }}
                                        >
                                        <div className="sq-sub-plan-icon">
                                            <Icon size={20} color={p.accent} />
                                        </div>

                                        <div className="sq-sub-plan-body">
                                            <div className="sq-sub-plan-row">
                                                <div className="sq-sub-plan-label">
                                                    {p.label}
                                                </div>
                                                {active && (
                                                    <div
                                                        className="sq-sub-badge"
                                                        style={ { backgroundColor: p.accent }}
                                                        >
                                                        Seçildi
                                                    </div>
                                                )}
                                            </div>

                                            <div className="sq-sub-plan-sub">
                                                {p.subLabel}
                                            </div>
                                            <div className="sq-sub-plan-price">
                                                {p.amount.toLocaleString("az-AZ")} AZN
                                            </div>
                                        </div>
                                    </button>
                                );
                            })}
                        </div>

                        <div className="sq-sub-actions">
                            <button
                                type="button"
                                className="sq-sub-pay-btn"
                                onClick={handlePayment}
                                disabled={checking}
                                >
                                <IoCardOutline size={18} color="#fff" />
                                <span>{checking ? "Yoxlanılır...": "Ödəniş et və aktivləşdir"}</span>
                            </button>

                            <button
                                type="button"
                                className="sq-sub-support-btn"
                                onClick={handleContactSupport}
                                >
                                <IoLogoWhatsapp size={18} color="#075E54" />
                                <span>Dəstək ilə əlaqə</span>
                            </button>

                            <div className="sq-sub-bottom-hint">
                                Ödəniş etmədən istifadə mümkün deyil. Suallar üçün “Dəstək ilə əlaqə” düyməsinə bas.
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {payOpen && (
                <div className="sq-modal-overlay sq-pay-overlay">
                    <div className="sq-pay-sheet">
                        {payUrl ? (
                            <iframe
                                src={payUrl}
                                title="Ödəniş"
                                className="sq-pay-frame"
                                />
                        ): (
                            <div className="sq-pay-loading">
                                Yüklənir…
                            </div>
                        )}

                        <button type="button" className="sq-pay-home-btn" onClick={handleClosePay}>
                            Ana səhifəyə qayıt
                        </button>
                    </div>
                </div>
            )}

            <AppMessageModal
                open={messageModal.open}
                title={messageModal.title}
                message={messageModal.message}
                type={messageModal.type}
                onClose={() =>
                setMessageModal((prev) => ({
                    ...prev,
                    open: false,
                }))
                }
                />
        </>

    );
};
export default SubModal;
